export const AUTH_PROMPT_TYPE = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  // FORGOT_PASSWORD: 'forgot_password',
  // RESET_PASSWORD: 'reset_password',
  // VERIFY_EMAIL: 'verify_email',
}

export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const TIME_FORMAT = 'HH:mm'